import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Link } from 'react-router-dom'
import { Users } from 'lucide-react'

export default function TeamHierarchyPlaceholder() {
  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-5xl mx-auto space-y-6">
        <header className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
            <Users className="w-5 h-5 text-primary" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-foreground">Team hierarchy</h1>
            <p className="text-muted-foreground">Visual organization tree is on the migration backlog.</p>
          </div>
        </header>

        <Card className="border-dashed">
          <CardHeader>
            <CardTitle>Hierarchy explorer</CardTitle>
            <CardDescription>
              The collapsible org chart from the Next.js app should be ported to this page. Until then, use the members list to
              review reporting lines.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <Button asChild>
              <Link to="/dashboard/team">View team roster</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
